import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetInvoicePaymentSyncHistoryController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoicePaymentSyncHistoryController.php
* @route '/api/invoicing/{invoice}/payment-sync-history'
*/
const GetInvoicePaymentSyncHistoryController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoicePaymentSyncHistoryController.url(args, options),
    method: 'get',
})

GetInvoicePaymentSyncHistoryController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/payment-sync-history',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetInvoicePaymentSyncHistoryController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoicePaymentSyncHistoryController.php
* @route '/api/invoicing/{invoice}/payment-sync-history'
*/
GetInvoicePaymentSyncHistoryController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetInvoicePaymentSyncHistoryController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetInvoicePaymentSyncHistoryController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoicePaymentSyncHistoryController.php
* @route '/api/invoicing/{invoice}/payment-sync-history'
*/
GetInvoicePaymentSyncHistoryController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetInvoicePaymentSyncHistoryController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetInvoicePaymentSyncHistoryController::__invoke
* @see app/Http/Controllers/Invoice/GetInvoicePaymentSyncHistoryController.php
* @route '/api/invoicing/{invoice}/payment-sync-history'
*/
GetInvoicePaymentSyncHistoryController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetInvoicePaymentSyncHistoryController.url(args, options),
    method: 'head',
})

export default GetInvoicePaymentSyncHistoryController